import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "px-container max-w-5xl mx-auto" }
const _hoisted_2 = { class: "md:grid grid-cols-3 mt-12 gap-4" }
const _hoisted_3 = { class: "relative w-48 h-48 mx-auto text-amff-teal" }
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  viewBox: "0 0 375 375",
  class: "absolute inset-0"
}, [
  /*#__PURE__*/_createVNode("circle", {
    cx: "187.5",
    cy: "187.5",
    r: "187.5",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-location": "inside",
    "stroke-dasharray": "16 8"
  })
], -1)
const _hoisted_5 = { class: "mt-4 text-amff-white" }
const _hoisted_6 = { class: "text-2xl font-bold" }
const _hoisted_7 = { class: "text-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")
  const _component_FollowFestival = _resolveComponent("FollowFestival")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_PageTitle, { class: "mt-10 md:mt-20" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("header.partakers")), 1)
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_2, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.partakers, (partaker) => {
          return (_openBlock(), _createBlock("div", {
            key: partaker.id,
            class: "my-8 lg:my-10 lg:w-64 block relative text-center"
          }, [
            _createVNode("div", _hoisted_3, [
              _hoisted_4,
              (partaker.imageCard)
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    src: partaker.getImageCard('186x0'),
                    srcset: 
              ['186', '372', '744']
                .map((size) => `${partaker.getImageCard(`${size}x0`)} ${size}w`)
                .join(', ')
            ,
                    alt: "",
                    class: "absolute inset-0 p-2 rounded-full w-full h-full object-cover"
                  }, null, 8, ["src", "srcset"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, _toDisplayString(partaker.fullName), 1),
              _createVNode("div", _hoisted_7, _toDisplayString(partaker.profession), 1)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_FollowFestival)
  ], 64))
}